import { useState } from 'react';
import Layout from '../../../Components/Layout/Layout';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import Toaster from '../../../Components/Toaster/Toaster';
import { useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import {
  AUTH_VISITOR_USER_FAILED,
  AUTH_VISITOR_USER_SUCCESS,
} from '../../../Helpers/Constant';
import fetcher from '../../../Helpers/Fetcher/fetchApi';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Loader from '../../../Components/Spinner/Loader';
import InputField from '../../../Components/Common/InputField';

interface inputForm {
  visitor_phoneOrEmail: string;
  password: string;
}
const VisitorRegister = () => {
  const {
    dispatch: authDispatch,
    isLoading,
    setIsLoading,
  } = VisitorAuthContext();
  const Toast = Toaster();
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm<inputForm>();
  const [passwordType, setPasswordType] = useState('password');

  const onSubmit: SubmitHandler<inputForm> = async (data) => {
    try {
      setIsLoading?.(true);
      const res = await fetcher.post({
        url: '/api/auth/visitor/login',
        contentType: 'application/json',
        body: data,
      });

      if (res.success) {
        Toast.fire({
          icon: 'success',
          title: `successfully login`,
        });
        authDispatch?.({
          type: AUTH_VISITOR_USER_SUCCESS,
          payload: { ...res.data, token: res.token },
        });
        localStorage.setItem('toab_visitor_token', res.token);
        setIsLoading?.(false);
        navigate('/visitor/profile');
      } else {
        Toast.fire({
          icon: 'error',
          title: res.message,
        });
        setIsLoading?.(false);
        authDispatch?.({ type: AUTH_VISITOR_USER_FAILED });
      }
    } catch (error) {
      authDispatch?.({ type: AUTH_VISITOR_USER_FAILED });
    }
  };
  return (
    <Layout>
      <div className='login-wrapper'>
        <div className='login-div'>
          <div className='visitor-login-page'>
            <div className='text-center'>
              <p className='fw-bold fs-3 py-1'>Visitor Login</p>
            </div>

            <div className='login-form'>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <div>
                    <InputField
                      label='Enter your email'
                      register={register('visitor_phoneOrEmail')}
                      type='text'
                      isRequired
                      placeholder='Enter your email address'
                    />
                  </div>
                </div>
                <div className='pt-3'>
                  <InputField
                    label='Enter your password'
                    register={register('password')}
                    type={passwordType}
                    isRequired
                    placeholder='Enter your password'
                  />
                </div>
                <div className=' pt-2 d-flex align-items-center justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <input
                      type='checkbox'
                      onClick={() => {
                        passwordType === 'password'
                          ? setPasswordType('text')
                          : setPasswordType('password');
                      }}
                    />
                    <p className='ps-2'>Show password</p>
                  </div>
                  <Link
                    to='/forget-password?type=forget_visitor'
                    style={{ textDecoration: 'none' }}
                  >
                    <p className='text-primary'>Forgot password</p>
                  </Link>
                </div>

                <div>
                  {isLoading ? (
                    <Loader css={'w-100 mt-5 text-white'} />
                  ) : (
                    <Button
                      type='submit'
                      className='w-100 mt-3 submit-button common-btn'
                    >
                      Login
                    </Button>
                  )}
                </div>
              </form>
              <div className='d-flex align-items-center my-4'>
                <div className='flex-grow-1 border-top border-secondary'></div>
                <span className='mx-2 py-2  text-black '>
                  <Link
                    to='/visitor-registration'
                    className='text-decoration-none'
                  >
                    Visitor register
                  </Link>
                </span>
                <div className='flex-grow-1 border-top border-secondary'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default VisitorRegister;
